import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';

const CustomPortal = ({children, domSelector, className = '', element = 'div', node = null}) => {
  if (!domSelector && !node) {
    return null;
  }
  const domNode = node || document.querySelector(domSelector);

  const [container] = React.useState(() => {
    if (node) return node;
    const el = document.createElement(element);
    if (className) {
      el.classList.add(className);
    }
    return el;
  });

  useEffect(() => {
    if (!node) {
      domNode.appendChild(container);
      return () => {
        domNode.removeChild(container);
      };
    }
  }, []);

  return createPortal(children, container);
};

export default CustomPortal;
